import store from "@/store";
import {
  publicEncrypt,
  symmetricDecrypt,
  symmetricEncrypt
} from "./cryptoUtils";
import request from "@/axios/axios";

import SparkMD5 from "spark-md5";



/**
 * 提交对象格式数据
 * @param url url链接
 * @param data 数据对象，Object，Array类型
 */
function safePost(url, data) {

  let params = convertData(data);
  let sign = params.sign;
  const body = symmetricEncrypt(JSON.stringify(params.data), sign);
  return request({
    url: url,
    method: "post",
    data: body,
    headers: params.headers
  })
    .then(resp => {
      if (resp.data != null) {
        resp.data = JSON.parse(symmetricDecrypt(resp.data, sign));
      }
      return Promise.resolve(resp);
    })
    .catch(resp => {
      return Promise.reject(resp);
    });
}

function convertData(data) {
  data = data || {};
  if (data instanceof Array) {
    const fields = data;
    data = {};
    for (let d of fields) {
      data[d.name] = d.value.trim();
    }
  }
  const headers = createHeader(data);
  const sign = signData(
    Object.assign(
      { nonceStr: headers.nonceStr, timeUnit: headers.timeUnit },
      data
    )
  );
  headers.sign = publicEncrypt(sign);
  return {
    data: data,
    headers: headers,
    sign: sign
  };
}

function createHeader(data) {
  const headers = {
    "Content-Type": "text/plain",
    "x-requested-with": "XMLHttpRequest",
    keyId: store.getters["User/publicKey"].keyId,
    clientType: "javascript",
    versionCode: 2
  };
  if (typeof data.nonceStr == "undefined") {
    headers.nonceStr = randomString();
  }
  if (typeof data.timeUnit == "undefined") {
    headers.timeUnit = new Date().getTime() + "";
  }
  return headers;
}

function signData(data) {
  let spark = new SparkMD5();
  return spark.append(sortParam(data)).end();
}

const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
const maxPos = chars.length;

function randomString() {
  let pwd = "";
  for (let i = 0; i < 32; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

function sortParam(data) {
  let keys = Object.keys(data);
  keys.sort(function(x, y) {
    if (x > y) {
      return 1;
    }
    return -1;
  });
  let paramArr = [];
  for (let k of keys) {
    paramArr.push(k + "=" + data[k]);
  }
  paramArr.push("key=5b8af47892d636624dde271aa5e19938");
  return paramArr.join("&");
}

export default {
  safePost: safePost,
};
